import { Routes } from '@angular/router';

import { RootComponent } from '../root/root.component';
import { ListComponent } from './list/list.component';
import { SummaryComponent } from './summary/summary.component';

import { AuthGuard } from '../auth.guard';

export const routing: Routes = [
  {
    path: 'job',
    data: {
      breadcrumb_en: 'Jobs',
      breadcrumb_es: 'Trabajos'
    },
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      {
        path: '', component: ListComponent,
        data: {
          breadcrumb_en: 'Job List',
          breadcrumb_es: 'Lista de Trabajos'
        },
      },
      {
        path: 'list', component: ListComponent,
        data: {
          breadcrumb_en: 'Job List',
          breadcrumb_es: 'Lista de Trabajos'
        },
      },
      {
        path: ':jobId', component: SummaryComponent,
        data: {
          breadcrumb_en: 'Manage Job',
          breadcrumb_es: 'Administrar Trabajo'
        },
      },
    ]
  }
];
